var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table__container"},[_c('header-page',[_vm._v(" Kas Harian ")]),_c('TableCash')],1)}
var staticRenderFns = []

export { render, staticRenderFns }